<template>
  <div class="container BlogRoot mb-3" v-if="WebinarItems && Categories">
    <main role="main" class="pb-3">
      <b-tabs :value="tabIndex">
        <b-tab
          class="card card-default border-0"
          :title="Cat.title"
          v-for="Cat in Categories"
          :key="Cat.id"
          :active="Cat == Categories[tabIndex]"
          @click="() => clicked_tab(Cat)"
        >
          <div class="card-body vertical-align px-0 pt-3 pb-0">
            <div class="col-md-10">
              <h1>{{ Cat.title }}</h1>
              <p>
                <LinkToTradespoon
                  :text="Cat.description"
                  :promotion_id="Cat.tradespoonId"
                />
              </p>
            </div>
            <div class="col-12 col-md-2 col-sm-2 pb-3 pb-md-0">
              <img
                class="img-fluid rounded-2 center-block"
                :src="'/images/' + Cat.imageUrl"
                alt="Trading Guide"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <div class="input-group col-md-8 col-xl-6 mb-4">
        <input
          class="form-control py-2"
          type="search"
          value="search"
          id="example-search-input"
          v-model="search_text"
        />
        <span class="input-group-append">
          <button
            class="btn btn-outline-secondary"
            type="button"
            @click="
              $emit('search', {
                type: 'recorded',
                CatId: Categories[tabIndex].id,
                Phrase: search_text,
                PerPage: 4,
                SkipPages: 0,
              })
            "
          >
            <i class="fa fa-search"></i>
          </button>
        </span>
      </div>
      <div
        class="card card-default border-top-0 border-right-0 border-left-0"
        v-for="(webinar, ind) in WebinarItems"
        :key="webinar.id"
      >
        <RecordedWebinar :webinar="webinar" :autoplay="ind == autoplayInd" />
      </div>
    </main>
    <b-pagination
      :value="currentPage"
      @change="paginationClicked"
      :totalRows="totalRows"
      :per-page="perPage"
    />
  </div>
</template>

<script>
import RecordedWebinar from "./RecordedWebinar.vue";
import LinkToTradespoon from "./LinkToTradespoon.vue";
//b-tabs @input="(ind)=>{$emit('loadCategory', {cat:Categories[ind], page:1})}"
export default {
  name: "RecordedWebinarsPage",
  components: {
    RecordedWebinar,
    LinkToTradespoon,
  },
  props: {
    showSearch: Boolean,
    WebinarItems: Array,
    Categories: Array,
    currentPage: Number,
    totalRows: Number,
    tabIndex: Number,
  },
  data() {
    return {
      search_text: "",
      perPage: 4,
    };
  },
  computed: {
    autoplayInd() {
      return this.WebinarItems.findIndex((o) => o.vimeoLink);
    },
  },
  methods: {
    paginationClicked(ind) {
      if (!this.showSearch)
        this.$emit("loadCategory", {
          cat: this.Categories[this.tabIndex],
          page: ind,
        });
      else
        this.$emit("search", {
          type: "recorded",
          CatId: this.Categories[this.tabIndex].id,
          Phrase: this.search_text,
          PerPage: 4,
          SkipPages: ind - 1,
        });
        window.scroll({
          top: 0,
          left: 0,
          behavior: "auto",
        });
    },
    clicked_tab(cat) {
      this.$emit("loadCategory", { cat, page: 1 });
    },
  },
};
</script>

<style>
</style>
